export const CLUB = {
  name: "Ferroviarios",
  city: "Puente Alto",
  fullName: "Ferroviarios Puente Alto",
  tagline: "Sports Club · American Football",
  logo: "https://customer-assets.emergentagent.com/job_tackle-manager-1/artifacts/e3opcxq4_LOGO%20FERRO%20%283%29.png",
};
